import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'OrderTechrulePipe', pure: false })
export class OrderTechrulePipe implements PipeTransform {
  static orderByComparator(a: any, b: any): number {
    if (a === undefined) {
      a = 0;
    }
    if (b === undefined) {
      b = 0;
    }

    if (
      isNaN(parseFloat(a)) ||
      !isFinite(a) ||
      isNaN(parseFloat(b)) ||
      !isFinite(b)
    ) {
      // Isn't a number so lowercase the string to properly compare
      if (a.toLowerCase() < b.toLowerCase()) {
        return -1;
      }
      if (a.toLowerCase() > b.toLowerCase()) {
        return 1;
      }
    } else {
      // Parse strings as numbers to compare properly
      if (parseFloat(a) < parseFloat(b)) {
        return -1;
      }
      if (parseFloat(a) > parseFloat(b)) {
        return 1;
      }
    }
    return 0; // equal each other
  }

  static getPropertyValue(prop: string, obj: any): any {
    return prop.split('.').reduce((memo: any, part: any) => {
      return memo[part];
    }, obj);
  }
  transform(input: any, config: string = '+'): any {
    // make a copy of the input's reference
    if (
      !Array.isArray(config) ||
      (Array.isArray(config) && config.length === 1)
    ) {
      const propertyToCheck: string = !Array.isArray(config)
        ? config
        : config[0];
      const desc = propertyToCheck.substr(0, 1) === '-';

      // Basic array
      if (
        !propertyToCheck ||
        propertyToCheck === '-' ||
        propertyToCheck === '+'
      ) {
        return !desc ? [...input].sort() : [...input].sort().reverse();
      } else {
        const property: string =
          propertyToCheck.substr(0, 1) === '+' ||
          propertyToCheck.substr(0, 1) === '-'
            ? propertyToCheck.substr(1)
            : propertyToCheck;
        return [...input].sort(function foo(a: any, b: any) {
          const valueA: any = OrderTechrulePipe.getPropertyValue(property, a);
          const valueB: any = OrderTechrulePipe.getPropertyValue(property, b);
          // console.log('a[property]', property, valueA);
          // console.log('b[property]', property, valueB);
          return !desc
            ? OrderTechrulePipe.orderByComparator(valueA, valueB)
            : -OrderTechrulePipe.orderByComparator(valueA, valueB);
        });
      }
    } else {
      // Loop over property of the array in order and sort
      return [...input].sort(function foo(a: any, b: any) {
        let i: number;
        for (i = 0; i < config.length; i++) {
          const desc = config[i].substr(0, 1) === '-';
          const property =
            config[i].substr(0, 1) === '+' || config[i].substr(0, 1) === '-'
              ? config[i].substr(1)
              : config[i];

          const valueA: any = OrderTechrulePipe.getPropertyValue(property, a);
          const valueB: any = OrderTechrulePipe.getPropertyValue(property, b);

          const comparison: any = !desc
            ? OrderTechrulePipe.orderByComparator(valueA, valueB)
            : -OrderTechrulePipe.orderByComparator(valueA, valueB);

          // Don't return 0 yet in case of needing to sort by next property
          if (comparison !== 0) {
            return comparison;
          }
        }

        return 0; // equal each other
      });
    }
  }
}
